import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Usuario} from '@kilobytelab/types';
import {Padre, Alumno} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiPadresService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** padres ***/

  getPadres(): Promise<Usuario[]> {
    const url = `${this.apiUrl}padres`;
    return firstValueFrom(this.http.get<Usuario[]>(url))
  }
  getPadre(id: number): Promise<Padre> {
    const url = `${this.apiUrl}padres/${id}`;
    return firstValueFrom(this.http.get<Padre>(url))
  }
  getPadreByNif(nif: string): Promise<Padre> {
    const url = `${this.apiUrl}padres/bynif/${nif}`;
    return firstValueFrom(this.http.get<Padre>(url))
  }
  enviarInstrucciones(id: number): Promise<any> {
    const url = `${this.apiUrl}padres/instrucciones/${id}`;
    return firstValueFrom(this.http.get<any>(url))
  }
  padresHuerfanos(): Promise<Padre[]> {
    const url = `${this.apiUrl}padres/huerfanos`;
    return firstValueFrom(this.http.get<Padre[]>(url))
  }
  getHijosAsociados(id: number): Promise<Alumno[]> {
    const url = `${this.apiUrl}padres/asociados/${id}`;
    return firstValueFrom(this.http.get<Alumno[]>(url))
  }
  getSearchPadres(str: string): Promise<Padre[]> {
    const url = `${this.apiUrl}padres/search`;
    return firstValueFrom(this.http.post<Padre[]>(url, {cadena: str}))
  }
  checkUserUsers(user: string): Promise<string> {
    const url = `${this.apiUrl}padres/checkuser`;
    return firstValueFrom(this.http.post<string>(url, {usuario: user}))
  }
  checkNIFUsers(dni: string, idUser: number): Promise<string> {
    const url = `${this.apiUrl}padres/checknif`;
    return firstValueFrom(this.http.post<string>(url, {nif: dni, id: idUser}))
  }
  updatePadre(datos: Padre & {userinit: string}): Promise<any> {
    const url = `${this.apiUrl}padres/update`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  sendCertificado(datos: {to: string[], tipo: string, url: string}): Promise<any> {
    const url = `${this.apiUrl}padres/certificados`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  deletePadre(id: number): Promise<any> {
    const url = `${this.apiUrl}padres/${id}`;
    return firstValueFrom(this.http.delete<any>(url))
  }
}
